import { BookOpen } from "lucide-react";
import PlaceholderPage from "./PlaceholderPage";

export default function Knowledge() {
  return (
    <PlaceholderPage 
      title="WorldVia Knowledge Base" 
      description="Access our comprehensive collection of travel resources, destination guides, and best practices."
      icon={<BookOpen size={48} />} 
    />
  );
}